<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-disapproval" title="MOTIVO DE REPROVAÇÃO">
      <div>
        <div class="form-group row">
          <div class="col-md-12 pt-2 pb-3">
            <label for="txtGroupsName"><small class="text-danger">*</small> {{$lang.EmployeeBoard.DisapprovalModal.LabelReason}}?</label>
            <div class="input-group">
              <b-form-textarea id="txtDescription"
                        name="txtDescription"
                        v-model="form.descricao.value"
                        :placeholder="$lang.EmployeeBoard.DisapprovalModal.PlaceholderReason"
                        :rows="form.descricao.rows"
                        :maxlength="form.descricao.maxlength"
                        :noResize="form.descricao.noResize"></b-form-textarea>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="sm"
            class="float-right"
            @click="onSave">
            <i class="fas fa-save"></i>&nbsp;
            Salvar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'

const formModal = {
  descricao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '6',
    noResize: true
  }
}
export default {
  name: 'DisapprovalModal',
  mixins: [ ActionsForm ],
  data () {
    return {
      form: formModal,
      showAlert: false
    }
  },
  methods: {
    showModal () {
      this.form.descricao.value = ''
      this.$refs['modal-disapproval'].show()
    },
    hideModal () {
      this.$refs['modal-disapproval'].hide()
    },
    onSave () {
      if (this.form.descricao.value) {
        this.$emit('Disapproval', this.form.descricao.value)
        this.hideModal()
      } else {
        toast.error(this.$lang.EmployeeBoard.DisapprovalModal.WarningReason)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/board/components/modal/disapprovalmodal.vue